import axios from 'axios';
import type {
  Integration,
  IntegrationPayload,
} from '@getaccept/lib-shared-new/src/integrations/types/integration';

export default class AuthorizeNetService {
  public static async fetchIntegration(
    documentId: string,
    recipientId: string,
    authId: string
  ): Promise<Integration> {
    const {
      data: { integrations },
    } = await axios.get(`/view/${documentId}/${recipientId}/${authId}/integrations`);
    const integration =
      integrations &&
      integrations.find((integration: IntegrationPayload) => integration.name === 'authorizenet');
    return {
      metaData_1: integration.meta_data_1,
      metaData_2: integration.meta_data_2,
      metaData_3: integration.meta_data_3,
      hasToken: integration.has_token,
      externalUrl: integration.external_url,
    };
  }
}
